import { Component, DestroyRef, Input, inject, signal } from '@angular/core';
import { Store } from '@ngrx/store';
import { GoogleAnalyticsService } from 'src/app/google-analytics.service';
import { UtilService } from 'src/app/util.service';
import { EntryService } from '../entry.service';
import { PlatformService } from 'src/app/platform.service';
import { EntryData, ProviderData } from '../structure-data.models';
import { combineLatest, filter, map, take } from 'rxjs';
import { EntrySelectors } from 'src/app/state/entry.selectors';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ConfigService } from 'src/app/config.service';
import { CommonService } from 'src/app/common.service';
import { ProviderCacheService } from '../ProviderCacheService';
import { EntryActions } from 'src/app/state/entry.actions';
@Component({
  selector: 'entry-page-footer',
  templateUrl: './entry-page-footer.component.html',
  styleUrl: './entry-page-footer.component.css',
  standalone: false
})
export class EntryPageFooterComponent {
  @Input() isEntryPage: boolean;
  public accession: string;
  public entryData = signal<EntryData>({} as EntryData);

  private readonly destroyRef = inject(DestroyRef);
  public providerData: ProviderData;

  constructor(
    private store: Store,
    public gaService: GoogleAnalyticsService,
    private configService: ConfigService,
    private commonService: CommonService,
    private providerCache: ProviderCacheService,
    private platform: PlatformService,
  ) {}
  async ngOnInit(): Promise<void> {  
    if(this.isEntryPage){
      // combineLatest([
      //   this.store.select(EntrySelectors.entryData).pipe()
      // ])
      // .pipe(
      //   map(([entryData]) => {
      //     this.entryData.set(entryData)
      //   }),
      //   takeUntilDestroyed(this.destroyRef)
      // )
      // .subscribe();
  
      // if(this.entryData() && this.entryData().providerId){
      //   this.getProviderData();
      // }
      // this.accession = this.entryData().uniprotAccession;
       combineLatest([
            this.store.select(EntrySelectors.entryData).pipe(),
          ])
            .pipe(
              filter(([entryData]) =>
                !!entryData &&
                !!entryData.modelEntityId 
              ),
              take(1),
              takeUntilDestroyed(this.destroyRef)
            )
            .subscribe(([entryData]) => {
              this.entryData.set(entryData);
              if(this.entryData() && this.entryData().providerId){
                this.getProviderData();
              }
              this.accession = this.entryData().uniprotAccession;
            });
    } 
  }

  public getProviderData(): void {
    const providerId = this.entryData().providerId;
    // 1. Try cached value
    if(this.platform.isBrowserPlatform()){
      const cachedData: ProviderData | null = this.providerCache.get<ProviderData>(providerId);
      if (cachedData) {
        this.providerData = cachedData;
        this.store.dispatch(
          EntryActions.setCurrentProvider({
            providerData: this.providerData
          })
        );
        return;
      }

      // 2. Otherwise, call API
      const auth = this.configService.getConfig().apiKey
        ? `?key=${this.configService.getConfig().apiKey}`
        : '';
      const apiUrl =
        this.configService.getConfig().providerApiUrl + providerId + auth;
      this.commonService.getApiData(apiUrl, { isInternal: true }).subscribe(
        (data) => {
          this.providerData = {
            providerName: data.providerName,
            toolUsed: this.entryData().toolUsed,
            providerUrl: data.providerUrl,
            feedback: data.feedback,
            license: data.license,
            citations: data.citations,
            copyrights: data.copyrights,
            modelCreatedDate: this.entryData().modelCreatedDate
          };
          this.store.dispatch(
            EntryActions.setCurrentProvider({
              providerData: this.providerData
            })
          );
          // Save in cache
          this.providerCache.set(providerId, this.providerData);
        },
        (error) => {
          
          this.providerData = {
            providerName : null,
            toolUsed: null,
            providerUrl: null,
            feedback: null,
            license: null,
            citations: null,
            copyrights: null,
            modelCreatedDate: null
          };
          this.store.dispatch(
            EntryActions.setCurrentProvider({
              providerData: this.providerData
            })
          );
          this.providerCache.set(providerId, this.providerData);
        }
      );
    }
  }
}
